import { render, staticRenderFns } from "./ProjectPaymentPlanDistributionPP.vue?vue&type=template&id=4d8386b0"
import script from "./ProjectPaymentPlanDistributionPP.vue?vue&type=script&lang=js"
export * from "./ProjectPaymentPlanDistributionPP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports